module.exports = __webpack_public_path__ + "static/media/usc.b6910a9c.png";